import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: "",
  processing: false,
  paymentList: [],
}

const paymentVerificationSlice = createSlice({
  name: "paymentVerificationSlice",
  initialState: initialState,
  reducers: {
    searchPaymentList: () => {
    },
    verifyPayment: () => {
    },
    setLoading: (state) => {
      state.loading = true
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setProcessing: (state) => {
      state.processing = true
    },
    setPaymentList: (state, action) => {
      state.paymentList = action.payload
      state.loading = false;
    },
    setSuccess: (state, action) => {
      const {payload} = action.payload
      state.paymentList = state.paymentList.filter((item) => item.id !== payload)
    }
  }
})

export const {
  searchPaymentList,
  verifyPayment,
  setLoading,
  setError,
  setProcessing,
  setPaymentList,
  setSuccess
} = paymentVerificationSlice.actions

export default paymentVerificationSlice.reducer;